// extracted by mini-css-extract-plugin
export var progressBar = "_ns-0";
export var progressBarInner = "_ns-1";